export default "__VITE_ASSET__CkSRdgGm__"